import React, { useEffect } from "react";
import AppForms from "@toothfairy/shared-ui/AppForms";
import { isLargeScreen } from "../../../../MainViewContainer";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import Constants from "../../../../../Constants";
import { AppText } from "@toothfairy/shared-ui";
import { View } from "react-native";
import AppAssets from "@toothfairy/shared-ui/AppAssets";

const QaHiringResourcesInstancesLeaf = ({
  u,
  onTick = () => {},
  isTicked = true,
  isRecap = false,
}) => {
  const { currentTheme } = AppTheme.useTheme();
  const [isChecked, setIsChecked] = React.useState(isTicked);
  // useEffect(() => {
  //   setIsChecked(isTicked);
  // }, [isTicked]);
  return (
    <View
      style={{
        flexDirection: "column",
        alignItems: "flex-start",
        marginHorizontal: 10,
        gap: 5,
        marginBottom: 10,
      }}
    >
      <AppText
        leftIcon={
          !isRecap
            ? isChecked
              ? AppAssets?.icons?.check
              : AppAssets?.icons?.uncheck
            : null
        }
        isClickable
        isHoverable={false}
        onLeftIconPress={() => {
          const _v = !isChecked;
          setIsChecked(_v);
          onTick(_v);
        }}
        iconSize={14}
        style={{
          marginLeft: isRecap ? 0 : 10,
          fontWeight: "bold",
        }}
      >
        {u.name}
      </AppText>
      {!isRecap && <AppText>{u.description}</AppText>}
    </View>
  );
};

export default QaHiringResourcesInstancesLeaf;
